import { render, staticRenderFns } from "./obtain-th.vue?vue&type=template&id=42d59733&"
import script from "./obtain-th.vue?vue&type=script&lang=js&"
export * from "./obtain-th.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports